import React from "react"
import useDateTime from "./hooks/useDateTime"
import {ReactComponent as WaWiLogo} from './assets/wawi-logo.svg'
import './index.scss'

const Header: React.FC = () => {
    const {date, time} = useDateTime()
    return (
        <header>
            <div className="brand">
                <div className="logo"><WaWiLogo/></div>
                <div className="brand-info">
                    <p className="brand-name"><b>WaWi</b>Assist</p>
                    <p className="brand-desc">Produktionsverwaltung</p>
                </div>
            </div>
            <div className="date-time">
                <p className="time">{time}</p>
                <p className="date">{date}</p>
            </div>
        </header>
    )
}

export default Header